import primaryButtonDisabled from '../../../../../common/algorithms/primary-button-disabled';

const dark = (params) => primaryButtonDisabled(params);

export default dark;
